'use client';

import React from 'react';
import { GAMES } from '@/lib/landing-constants';

const Games: React.FC = () => {
  return (
    <section id="games" className="py-24 bg-white">

      <div className="container mx-auto px-6">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-20">
          <span className="text-violet-600 font-bold tracking-wider uppercase text-xs bg-white px-3 py-1 rounded-full border border-violet-100 shadow-sm">Brand‑safe Mini‑Games</span>
          <h2 className="text-3xl md:text-5xl font-display font-bold text-gray-900 mt-6 mb-6">
            Choose Your <br/>Customer&apos;s Adventure
          </h2>
          <p className="text-gray-600 text-lg leading-relaxed">
            From quick prize wheels to brain‑teasing puzzles. Every experience captures opt‑in customer data while staying on‑brand.
          </p>
        </div>

        {/* Games Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {GAMES.map((game, idx) => (
            <div
              key={game.id}
              className="group relative"
            >
              {/* Card */}
              <div className="bg-white rounded-3xl p-8 border border-gray-100 hover:border-violet-200 hover:shadow-2xl hover:shadow-violet-500/10 transition-all duration-300 h-full flex flex-col">

                {/* Icon & Badge */}
                <div className="flex items-start justify-between mb-6">
                  <div className="text-6xl">{game.icon}</div>
                  <div className="flex flex-col gap-2">
                    <span className="text-xs font-bold px-3 py-1 rounded-full bg-violet-100 text-violet-700">
                      {game.category}
                    </span>
                  </div>
                </div>

                {/* Content */}
                <h3 className="text-2xl font-bold text-gray-900 mb-3">{game.name}</h3>
                <p className="text-gray-600 text-sm leading-relaxed mb-6 flex-grow">
                  {game.description}
                </p>
              </div>

            </div>
          ))}
        </div>

        {/* Bottom CTA */}
        <div className="mt-16 text-center">
          <p className="text-gray-600 text-lg mb-6">
            Mix and match games for different campaigns. Track which games drive the most conversions.
          </p>
        </div>
      </div>
    </section>
  );
};

export default Games;
